// extracted by mini-css-extract-plugin
export default {"ckEditor":"addForm_ckEditor__5D-Ow","ck-content":"addForm_ck-content__O21n8"};